import { useEffect, useState } from 'react'

import { useIsAuthed } from 'components/AuthShield'

export const useOutreachMessageCount = ({
  initialValue,
  realtimeConnect,
  userId,
  updateUnreadOutreachMessageCount,
}) => {
  const isAuthed = useIsAuthed()
  const [unreadOutreachMessageCount, setUnreadOutreachMessageCount] = useState(initialValue)
  useEffect(() => {
    let unmounted = false
    if (isAuthed && realtimeConnect) {
      realtimeConnect(`${userId}-OutreachMessage`, ({ UnreadCount }) => {
        if (!unmounted) {
          updateUnreadOutreachMessageCount(UnreadCount)
          setUnreadOutreachMessageCount(UnreadCount)
        }
      })
    }
    return () => {
      unmounted = true
    }
  }, [userId, realtimeConnect, updateUnreadOutreachMessageCount, isAuthed])

  return unreadOutreachMessageCount
}
